import { InfoCircle } from 'react-bootstrap-icons';
import BasicCard from '../basicCard/BasicCard';
import { Spin } from 'antd';

interface IStatCard {
  isLoading?: boolean;
  value: number | string;
  icon: any;
  postfix?: string | JSX.Element;
  prefix?: string | JSX.Element;
  title: string;
  statColor?: string;
  valueSize?: number;
  info?: string;
}

const StatCard = (props: IStatCard) => {
  const { isLoading, value, icon, postfix, prefix, title, statColor, valueSize, info } = props;

  return (
    <BasicCard radius="lg">
      <div className="stat-card flex h-full w-full cursor-default flex-row items-center gap-6 px-6 py-4">
        <div className="flex aspect-square size-12 md:size-20 items-center justify-center rounded-full border-2 bg-gradient-to-t from-secondary to-primary p-4 text-2xl text-white">
          {icon}
        </div>
        <div className="space-y-2">
          {isLoading ? (
            <div className="flex w-full flex-row items-center !justify-center">
              <Spin size="large" />
            </div>
          ) : (
            <>
              <h3
                style={{ color: statColor && statColor }}
                className={`flex font-medium leading-none text-headings-font-color text-[20px] md:text-[30px]`}
              >
                {prefix && prefix}
                {value} {postfix && postfix}{' '}
              </h3>
              <p className="text-[12px] md:text-[16px] text-font-color">{title}
              {info && (
                <span>
                  <InfoCircle
                    className="ml-4 inline text-blue-500"
                    title={info}
                  />
                </span>
              )}
              </p>
            </>
          )}
          
        </div>
      </div>
    </BasicCard>
  );
};

export default StatCard;
